export const siteConfig = {
  name: "Кухлик",
  shortName: "Кухлик",
  description:
    "Кухлик — сучасний український портал про домашні заготовки, консервацію, ферментацію та сезонну кухню. Рецепти, покрокові поради, калькулятори пропорцій, добірки і корисні підказки для впевненого приготування вдома.",
  url: "https://kuhlyk.com",
  ogImage: "/images/og/kuhlyk-og.jpg",
  locale: "uk_UA",
  language: "uk",
  creator: "Vectora Systems",
  organizationName: "Кухлик",
  defaultTitle: "Кухлик — домашні заготовки, консервація і сезонна кухня",
  titleTemplate: "%s — Кухлик",
  keywords: [
    "домашні заготовки",
    "консервація",
    "ферментація",
    "сезонна кухня",
    "рецепти на зиму",
    "заготовки на зиму",
    "домашня консервація",
    "маринади",
    "соління",
    "квашення",
    "варення",
    "компоти",
    "аджика",
    "лечо",
    "огірки на зиму",
    "помідори на зиму",
    "стерилізація банок",
    "пропорції для маринаду",
    "калькулятор маринаду",
    "конвертер оцту",
    "рецепти домашніх заготовок",
    "заготовки з огірків",
    "заготовки з помідорів",
    "квашена капуста",
    "сезонні рецепти",
  ],
  mascot: {
    name: "Кухлик",
    role: "кот-помічник порталу",
    shortBio:
      "Кухлик — доброзичливий і уважний кухонний кіт, який допомагає знаходити перевірені рецепти, розраховувати пропорції та уникати типових помилок у консервації й ферментації.",
  },
  social: {
    email: "hello@kuhlyk.com",
    instagram: "https://instagram.com/kuhlyk",
    facebook: "https://facebook.com/kuhlyk",
    pinterest: "https://pinterest.com/kuhlyk",
  },
  legal: {
    privacyPath: "/privacy-policy",
    termsPath: "/terms-of-use",
  },
} as const

export type SiteConfig = typeof siteConfig